export default __webpack_public_path__ + "static/media/money-plant-background-left.7399a6ae.svg";